import yaml from 'js-yaml'

import { bus } from '../../utils'
import InformationModelDelete from '../InformationModelDelete/InformationModelDelete.vue'
import InformationModelImagesUpload from '../InformationModelImagesUpload/InformationModelImagesUpload.vue'
import InformationModelUpload from '../InformationModelUpload/InformationModelUpload.vue'

export default {
  beforeDestroy () {
    bus.$off('get-information-model-list')
  },
  components: { InformationModelDelete, InformationModelImagesUpload, InformationModelUpload },
  computed: {
    componentTitle () {
      return this.$t(`ComponentTitle.${this.$route.name}`)
    },
    defaultSort () {
      return { prop: 'timestamp', order: 'descending' }
    }
  },
  methods: {
    addInformationModal () {
      bus.$emit('add-information-modal', true)
    },
    convertToArray (im) {
      const arrayData = Object.keys(im).map((key) => {
        const value = im[key]
        value.formatedDate = value.timestamp
        value.index = key

        const fileType = value.name.split('.').pop()
        const infoModel = value.informationModel
        let data = JSON.stringify(infoModel)
        if (fileType === 'yaml' || fileType === 'yml') {
          data = yaml.safeDump(infoModel)
        }
        const blob = new Blob([data], { type: 'octet/stream' })
        value.downloadLink = window.URL.createObjectURL(blob)

        return value
      })

      return arrayData
    },
    getImageSrc (model = {}) {
      if (this.hasNoImages(model)) {
        return null
      }
      const images = model.images
      return (images.thumbnail && images.thumbnail.uri) || (images.banner && images.banner.uri)
    },
    getInformationModels () {
      this.loading = true
      return this.$api.getInfoModels()
        .then(({ data: informationModels }) => this.updateModelList(informationModels))
        .catch(() => this.updateModelList([]))
    },
    hasNoImages (model = {}) {
      const images = model.images || {
        banner: {},
        thumbnail: {}
      }

      const noImages = Object.keys(images).length === 0
      if (noImages) {
        return true
      }

      const noBanner = !images.banner || Object.keys(images.banner).length === 0
      const noThumbnail = !images.thumbnail || Object.keys(images.thumbnail).length === 0

      return noBanner && noThumbnail
    },
    removeInformationModel (familyName) {
      bus.$emit('show-delete-information-model', {
        show: true,
        familyName
      })
    },
    showSetImagePopup (model, isEdit) {
      bus.$emit('show-upload-information-model-images', {
        familyName: model.familyName,
        images: model.images,
        show: true
      })
    },
    updateModelList (models) {
      const arrayIM = this.convertToArray(models)
      this.informationModels = arrayIM
      this.loading = false
    }
  },
  async mounted () {
    await this.getInformationModels()
  },
  created () {
    bus.$on('get-information-model-list', () => this.getInformationModels())
  },
  data () {
    return {
      downloadData: {
        name: '',
        url: undefined
      },
      informationModels: [],
      loading: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/InformationModel/InformationModel.js